// stretchMarksData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[] | any;
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const stretchMarks: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Best Stretch Marks Removal in Dubai | Effective Treatment for Smoother Skin",
            "description": "Professional stretch marks removal in Dubai using advanced techniques to reduce visibility and improve skin texture. Book your consultation today for personalized treatment.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/stretch-marks-removal/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Best Stretch Marks Removal in Dubai | Effective Treatment for Smoother Skin",
                "description": "Professional stretch marks removal in Dubai using advanced techniques to reduce visibility and improve skin texture. Book your consultation today for personalized treatment.",
                "url": "https://elitebodyhome.com/services/stretch-marks-removal/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:54:57+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Stretch Marks Removal Dubai",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Best Stretch Marks Removal in Dubai | Effective Treatment for Smoother Skin",
                "description": "Professional stretch marks removal in Dubai using advanced techniques to reduce visibility and improve skin texture. Book your consultation today for personalized treatment.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Stretch Marks Removal"],
        "hero": {
            "title": "Stretch Marks Removal",
            "subtitle": "",
            "description": "Stretch marks (striae) are long, narrow stripes or lines that develop on the surface of the skin when it is overstretched and tear. Not only do these marks form on the belly, the thighs, the hips and the bust, these can be a source of despair for many who desire nothing than skin which is smoother and more uniform in shade. The good news is that you can now minimize the look of stretch marks and return your skin to its original beauty, with our state-of-the-art treatments at Elite Body Home Polyclinic."
        },
        "howItWorks": {
            "title": "Stretch Marks Removal Procedure",
            "description": "The removal of Stretch Marks usually requires a combination of treatments that are targeted to reduce their visibility and improve the texture of the skin."
        },
        "procedureSteps": {
            "heading": "",
            "para": "",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "The dermatologist evaluates the skin for severity/stage (early red/purple or matured white/silvery) of stretch marks and advises an ideal modality of treatment.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "Microneedling",
                    "desc": "Micro needles are applied to the skin to stimulate natural healing and to generate collagen to smooth out and fade stretch marks.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Radiofrequency (RF) Therapy",
                    "desc": "The RF energy tightens and firms the overlying skin, inducing collagen and elastin production, causing the stretch marks to fade and the skin to tighten.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Chemical Peels",
                    "desc": "Special peels peel the surface of the skin, reducing the look of stretch marks and improving the quality of the skin.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "Therapeutic PRP",
                    "desc": "PRP harnesses the power of the patient's own blood to create a high concentration of growth factors and promote tissue renewal.",
                    "icon": "fa-solid fa-dna"
                },
                {
                    "title": "Fractional Laser",
                    "desc": "Targets deep into the skin's dermal layer to increase collagen and heal the damaged skin, which reduces both new and old marks.",
                    "icon": "fa-solid fa-lightbulb"
                },
                {
                    "title": "Follow-Up & Aftercare",
                    "desc": "Use of good skincare such as moisturizer and sunblock are important to achieve the best long-term results.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Stretch Marks Removal",
            "subheading": "",
            "para": "Even beyond aesthetics, getting rid of stretch marks is a way to help someone feel more confident and to be better to their skin in general. Choose to get rid of stretch marks at Elite Body Home Polyclinic and enjoy:",
            "items": [
                {
                    "title": "Reduces Stretch Marks Visibly",
                    "desc": "What treatments do is fade discoloration and resurface textured skin.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "Improved Skin Elasticity",
                    "desc": "By boosting collagen production, skin will appear firmer and more resilient.",
                    "icon": "fa-solid fa-arrows-up-down"
                },
                {
                    "title": "Enhanced Skin Tone & Texture",
                    "desc": "Your skin will appear more even and have a smoother, softer texture.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Boosted Confidence",
                    "desc": "The self-esteem-related benefits of the result, which is development of a smoother, clearer skin, are numerous.",
                    "icon": "fa-solid fa-face-smile"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Stretch marks removal is great for those who want to lessen stretch marks caused by skin stretching from several different reasons. But eligibility needs to be evaluated to make sure the treatment is right for your skin type and expectations.",
            "items": [
                {
                    "title": "New and Old Stretch Marks",
                    "desc": "Whether you have fresh red marks or older, white stretch marks, treatments can make a difference for both.",
                    "icon": "fa-solid fa-timeline"
                },
                {
                    "title": "Following Pregnancy or Weight Increase",
                    "desc": "Good candidates are those who have stretch marks as a result of pregnancy or a change in weight.",
                    "icon": "fa-solid fa-baby-carriage"
                },
                {
                    "title": "Healthy Skin",
                    "desc": "Patients may not have any ongoing skin infections or conditions that could impair wound healing.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "Realistic Expectations",
                    "desc": "Total elimination is not always possible in severe stretch marks, although they can be reduced considerably.",
                    "icon": "fa-solid fa-scale-balanced"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "If you want to get the best results with your stretch marks removal treatment, you will need to prepare properly. Your specialist will provide you with pre-treatment advice and will assist in ensuring you prescreen according to the treatment guidelines.",
            "items": [
                {
                    "title": "Avoid Sun Exposure",
                    "desc": "Try not to let your skin tan or get sunburnt, as tanned or damaged skin can be less reactive to treatments.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Stop Some Skin Care Products",
                    "desc": "You might also be asked to suspend using products with retinoids, acids or other potent ingredients that can irritate skin.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Your skin will be in a better state of health if you are properly hydrated and thus more receptive for treatment.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Consult Your Specialist",
                    "desc": "Any medications or skin conditions should be brought to your specialists attention to avoid complications.",
                    "icon": "fa-solid fa-user-doctor"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Stretch marks removal products offer visible results that can improve the look and feel of your skin. It is important to have realistic expectations and know that while treatments can provide a significant improvement, the results will depend on the method — and the state of your skin.",
            "items": [
                {
                    "title": "Visible Better Skin Texture",
                    "desc": "Eventually stretch marks will lighten and your skin will be smoother.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "Gradual Results",
                    "desc": "Collagen always takes time to be stimulated, so plan to see results anywhere from a few weeks post sessions.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "Natural-Looking Skin",
                    "desc": "Your skin will become more even toned and have a softer, healthier appearance.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Long-Lasting Effects",
                    "desc": "The benefits of your stretch marks removal procedure can be long-lasting when treated with the proper care.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How many sessions will I need to see results?",
                    "answer": "The number of sessions required depends on the treatment chosen and the severity of your stretch marks. On average, patients may need 3-6 sessions for optimal results."
                },
                {
                    "question": "Are the treatments painful?",
                    "answer": "Most stretch marks removal treatments are minimally invasive and involve little discomfort. Numbing creams or cooling devices may be used to increase comfort during procedures."
                },
                {
                    "question": "Can stretch marks be completely removed?",
                    "answer": "While treatments significantly reduce the appearance of stretch marks, complete removal may not be possible, especially for older or more severe marks. However, visible improvement is achievable in most cases."
                },
                {
                    "question": "How long do the results last?",
                    "answer": "Results from stretch marks removal treatments can last for years, but maintaining a healthy lifestyle and skincare routine can prolong the effects."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Stretch-Marks-Removal-scaled.jpg",
            "beforeAfter": [
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Stretch-Marks-Removal-in-dubai-1.jpg", "alt": "stretch mark Removal Dubai" },
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Stretch-Marks-Removal-in-dubai-2.jpg", "alt": "stretch mark Removal Dubai" },
                { "src": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Stretch-Marks-Removal-in-dubai-3.jpg", "alt": "stretch mark Removal Dubai" }
            ],
            "introductionImage": "https://example.com/intro-image.jpg"
        },
        "product": {
            "id": 401,
            "title": "Stretch Marks Removal Package",
            "price": 799,
            "description": "Comprehensive stretch marks removal package including consultation, treatment sessions, and follow-up care. Our expert team offers effective solutions tailored to your skin."
        }
    },
    "ar": {
        "url": "",
        "meta": {
            "title": "أفضل علاج لإزالة علامات التمدد في دبي | تقليل مظهر الخطوط البيضاء",
            "description": "علاج احترافي لإزالة علامات التمدد في دبي باستخدام تقنيات متطورة لتقليل ظهورها وتحسين ملمس البشرة. احجز استشارتك اليوم للحصول على علاج مخصص.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/ar/services/stretch-marks-removal/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "أفضل علاج لإزالة علامات التمدد في دبي | تقليل مظهر الخطوط البيضاء",
                "description": "علاج احترافي لإزالة علامات التمدد في دبي باستخدام تقنيات متطورة لتقليل ظهورها وتحسين ملمس البشرة. احجز استشارتك اليوم للحصول على علاج مخصص.",
                "url": "https://elitebodyhome.com/ar/services/stretch-marks-removal/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:54:57+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "علاج علامات التمدد دبي",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "أفضل علاج لإزالة علامات التمدد في دبي | تقليل مظهر الخطوط البيضاء",
                "description": "علاج احترافي لإزالة علامات التمدد في دبي باستخدام تقنيات متطورة لتقليل ظهورها وتحسين ملمس البشرة. احجز استشارتك اليوم للحصول على علاج مخصص.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-38.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "إزالة علامات التمدد"],
        "hero": {
            "title": "علاج علامات التمدد",
            "subtitle": "",
            "description": "علامات التمدد أو الستراي هي خطوط طويلة ورفيعة تظهر على سطح الجلد بسبب تمدد البشرة بشكل مفرط، ولا تقتصر هذه العلامات على منطقة البطن فقط، بل قد تظهر أيضًا على الفخذين، والوركين، والصدر، وقد تكون مصدرًا للانزعاج للكثيرين ممن يرغبون في بشرة أكثر نعومة وتجانسًا في اللون. يعد الخبر السار هو أنه يمكنك الآن تقليل مظهر علامات التمدد واستعادة جمال بشرتك الطبيعي من خلال أنواع العلاج المتطورة التي نقدمها في عيادات ايليت بودي هوم."
        },
        "howItWorks": {
            "title": "إجراء إزالة علامات التمدد",
            "description": "تتطلب إزالة علامات التمدد مزيجًا من أنواع العلاج التي تهدف إلى تقليل وضوحها وتحسين ملمس البشرة."
        },
        "procedureSteps": {
            "heading": "",
            "para": "",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "يُقيم الطبيب حالة الجلد ومرحلة علامات التمدد، سواء كانت حمراء أو أرجوانية في بداية ظهورها أو بيضاء أو فضية ناضجة، ويحدد أنسب طريقة للعلاج.",
                    "icon": "fa-solid fa-user-doctor"
                },
                {
                    "title": "الميكرونيدلينغ",
                    "desc": "يُستخدم الوخز بالإبر الدقيقة على الجلد لتحفيز عملية الشفاء الطبيعية وزيادة إنتاج الكولاجين، مما يساعد على تنعيم الجلد وتفتيح علامات التمدد تدريجيًا.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "علاج الراديو فريكونسي",
                    "desc": "لا يتم امتصاص طاقة الراديوي فريكونسي من قبل الطبقة الخارجية للبشرة، بل تصل إلى الأدمة الوسطى، مما يعني أنها لا تؤثر مباشرةً على ندبات علامات التمدد، لكنها تعمل على شد الجلد وتحفيز إنتاج الكولاجين والإيلاستين، مما يؤدي إلى تلاشي علامات التمدد تدريجيًا وتحسن ملمس البشرة وتماسكها.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "التقشير الكيميائي",
                    "desc": "تُستخدم مقشرات خاصة لإزالة الطبقة السطحية من الجلد، مما يحسن مظهر علامات التمدد ويجعل البشرة أكثر نعومة.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "علاج البلازما الغنية بالصفائح الدموية (PRP)",
                    "desc": "يستفيد هذا العلاج من دم المريض نفسه لاستخلاص تركيز عالي من عوامل النمو التي تعزز تجدد الأنسجة وتحسن ملمس الجلد وتقلل من وضوح علامات التمدد.",
                    "icon": "fa-solid fa-dna"
                },
                {
                    "title": "العلاج بالفراكشنال ليزر",
                    "desc": "تستهدف أجهزة الفراكشنال ليزر المناطق الشائعة مثل منطقة ما حول السرة، حيث تخترق الطبقات العميقة من الجلد لتحفيز إنتاج الكولاجين وتجديد الأنسجة، مما يقلل من مظهر العلامات القديمة والجديدة.",
                    "icon": "fa-solid fa-lightbulb"
                },
                {
                    "title": "المتابعة والعناية بعد الإجراء",
                    "desc": "يُنصح باستخدام مرطب مناسب وواقي شمس عالي الجودة بعد الجلسات، للحفاظ على النتائج طويلة الأمد وللوقاية من ظهور علامات تمدد جديدة.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد إزالة علامات التمدد",
            "subheading": "",
            "para": "لا تقتصر إزالة علامات التمدد على الجوانب الجمالية فقط، بل تساهم أيضًا في تعزيز الثقة بالنفس والعناية بصحة البشرة بشكل عام. اختر إزالة علامات التمدد في عيادات ايليت بودي هوم واستمتع بالمزايا التالية:",
            "items": [
                {
                    "title": "تقليل واضح لعلامات التمدد",
                    "desc": "يساعد العلاج على تفتيح التصبغات وتجديد سطح البشرة، مما يقلل من مظهر العلامات بشكل ملحوظ.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "تحسن في مرونة البشرة",
                    "desc": "ستظهر البشرة أكثر تماسكًا ومتانة من خلال تحفيز إنتاج الكولاجين.",
                    "icon": "fa-solid fa-arrows-up-down"
                },
                {
                    "title": "تحسين لون وملمس البشرة",
                    "desc": "يصبح لون البشرة أكثر تجانسًا ويتحقق ملمس أكثر نعومة.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "يساعد الحصول على بشرة أكثر نعومة وصفاءً في تحسين مستوى الرضا والثقة بالنفس.",
                    "icon": "fa-solid fa-face-smile"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "تُعد إزالة علامات التمدد خيارًا مثاليًا للأشخاص الذين يرغبون في التخفيف من مظهر العلامات الناتجة عن تمدد الجلد لأسباب متعددة، ولكن يجب تقييم مدى ملاءمة العلاج حسب نوع البشرة والتوقعات المرجوة.",
            "items": [
                {
                    "title": "علامات التمدد الحديثة والقديمة",
                    "desc": "يمكن أن يحدث العلاج فرقًا واضحًا في مظهر العلامات سواء كانت لا تزال حمراء وحديثة أو بيضاء ومزمنة.",
                    "icon": "fa-solid fa-timeline"
                },
                {
                    "title": "بعد الحمل أو تغير الوزن",
                    "desc": "يعتبر المرشحون المناسبون هم من ظهرت لديهم علامات التمدد نتيجة الحمل أو زيادة الوزن أو نقصانه.",
                    "icon": "fa-solid fa-baby-carriage"
                },
                {
                    "title": "بشرة صحية",
                    "desc": "يجب ألا يكون لدى المريض أي التهابات أو أمراض جلدية نشطة قد تعيق عملية الشفاء بعد العلاج.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "توقعات واقعية",
                    "desc": "رغم أن العلاج يمكن أن يقلل من مظهر علامات التمدد بشكل كبير، إلا أن إزالتها بالكامل قد لا تكون ممكنة في الحالات الشديدة.",
                    "icon": "fa-solid fa-scale-balanced"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يلزم التحضير الجيد قبل بدء العلاج للحصول على أفضل النتائج من جلسات إزالة علامات التمدد. سيقوم المتخصص بإعطائك التعليمات اللازمة قبل الجلسة لضمان تحقيق أفضل استجابة للعلاج وتفادي أي مضاعفات.",
            "items": [
                {
                    "title": "تجنب التعرض لأشعة الشمس",
                    "desc": "يُنصح بتجنب تعرض الجلد للشمس أو جلسات التان قبل الموعد، حيث قد لا تستجيب البشرة المحترقة للعلاج.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "إيقاف بعض منتجات العناية بالبشرة",
                    "desc": "قد يُطلب منك التوقف مؤقتًا عن استخدام المنتجات التي تحتوي على الريتينويدات أو الأحماض أو أي مكونات فعالة قد تُسبب تهيجًا للبشرة قبل العلاج.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "الحفاظ على ترطيب جسمك",
                    "desc": "اشرب كميات كافية من الماء يوميًا للحفاظ على ترطيب البشرة، مما يُحسن من مرونتها واستجابتها للعلاج.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "استشارة الأخصائي",
                    "desc": "يجب إبلاغ الطبيب المتخصص بأي أدوية تتناولها أو مشكلات جلدية حالية لديك، لضمان أن العلاج آمن وفعال لحالتك.",
                    "icon": "fa-solid fa-user-doctor"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يمنحك علاج إزالة علامات التمدد نتائج ملحوظة في تحسن مظهر البشرة وملمسها. يجب امتلاك توقعات واقعية، حيث تعتمد النتائج على نوع الإجراء المُستخدم وحالة بشرتك.",
            "items": [
                {
                    "title": "تحسن ملمس البشرة",
                    "desc": "تبدأ علامات التمدد بالتلاشي تدريجيًا مع مرور الوقت، وتصبح البشرة أكثر نعومة وتجانسًا.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "نتائج تدريجية",
                    "desc": "يتطلب تحفيز إنتاج الكولاجين وقت، لذا تبدأ النتائج بالظهور عادة بعد عدة أسابيع من بدء الجلسات.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "مظهر طبيعي للبشرة",
                    "desc": "يصبح لون البشرة أكثر توحدًا، مع مظهر صحي وأكثر إشراقًا دون مبالغة أو تغيرات مصطنعة.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "نتائج تدوم طويلًا",
                    "desc": "يمكن أن تدوم نتائج علاج إزالة علامات التمدد لفترة طويلة عند الالتزام بالعناية اللاحقة المناسبة.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة المكررة",
            "subheading": "",
            "items": [
                {
                    "question": "كم عدد الجلسات المطلوبة لرؤية النتائج؟",
                    "answer": "يعتمد عدد الجلسات على نوع العلاج المُستخدم وشدة علامات التمدد. قد يحتاج المرضى من 3 إلى 6 جلسات بشكل عام لتحقيق أفضل النتائج."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "تُعد معظم طرق إزالة علامات التمدد غير جراحية وتتسبب في القليل من الانزعاج. يمكن استخدام كريمات التخدير أو أجهزة التبريد لضمان الراحة أثناء الإجراء."
                },
                {
                    "question": "هل يمكن إزالة علامات التمدد نهائيًا؟",
                    "answer": "يساهم العلاج في تقليل مظهر علامات التمدد بشكل ملحوظ، لكن قد لا تكون إزالتها بالكامل ممكنة، خاصةً في الحالات القديمة أو الشديدة. ومع ذلك، يمكن تحقيق تحسن واضح في معظم الحالات."
                },
                {
                    "question": "كم تدوم النتائج؟",
                    "answer": "يمكن أن تدوم نتائج إزالة علامات التمدد لعدة سنوات، ولكن يساعد الحفاظ على نمط حياة صحي وروتين مناسب للعناية بالبشرة في إطالة مدة النتائج."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }
}